/** The world's address data, from `@libs/utils/world` (LIS-1173), for this
 *  package's current callers. */
export {
  countriesDialling,
  countryData,
  regionFits,
  regionOptions,
  type CountryData,
  type CountryFile,
  type RegionOption,
} from "@libs/utils/world";
